import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
//import * as Cookies from 'js-cookie'
import LoginApiService from './api/LoginApiService'
import { createStore } from 'vuex-extensions'


Vue.use(Vuex)

export default createStore(Vuex.Store,{
  state: {
    lang: "es",
    loginSuccess: false,
    loginError: false,
    staffControl: false,
    userName: null,
    userPass: null,
    acl: null,
    iniOps: null,
    idTienda: 22,
    opuid: '',
    wsid: 1,
    listaTiendaIds: [],
    products: [],
    ticketsAparcados: [],
    productsCart:[],
    npag: 1,
    totalPag: 0,
    tituloIcono: '',
    titulo: '',
    parametrosApp: null,
    userInfo: {
      AdminSYS4: false,
      instalacion: '',
      isLoggedIn: false,
      isSignedUp: false,
      hasSearched: 0,
      hasLookSearched: 0,
      hasTicketSearched: 0,
      name: '',
      productTitleSearched: '',
      productLocalizadorSearched: '',
      productEanSearched: '',
      productTemporadaSearched: [], 
      productColorSearched: [],
      productTallaSearched: [],
      productFamiliaSearched: [],
      tiendaSearched: [],
      stockOnlineSearched: false,
      productSeccionSearched: [],
      priceSearched: [],
      ticketVendedorSearched:'',
      ticketClienteSearched: '',
      ticketFechaDesdeSearched:'',
      ticketFechaHastaSearched:'',
      ticketTipoSearched:'',
      lookNombreSearched:'',
      lookValidadoSearched: false,
      lookLocalizadorSearched: '',
      sesion: null,
      uid: '',
    },
    // clienteInfo: {
    //   clienteId: '',
    //   clienteUid: '',
    //   likeList: [],
    // },
    clienteInfo: {
      datos: null,
      busquedaCliente: '',
      likeList: [],
    },
    systemInfo: {
      openLoginModal: false,
      openSignupModal: false,
      openCheckoutModal: false,
      openCarritoModal: false,
      openFiltro: false,
      openFiltroTickets: false,
      openFiltroLooks: false,
      openBusqueda: false,
      openTickets: false
    }
  },
  getters: {
    lang: state => state.lang,
    isLoggedIn: state => state.loginSuccess,
    isAdminSYS4: state => state.userInfo.adminSYS4,
    hasLoginErrored: state => state.loginError,
    getUserName: state => state.userName,
    getUserPass: state => state.userPass,
    getAcl: state => state.acl,
    getIdTienda: state => state.idTienda,
    getOpuid: state => state.opuid,
    getWsid: state => state.wsid,
    getTiendaIds: state => state.listaTiendaIds,
    getProductsCart: state => state.productsCart,
    getTicketsAparcados: state => state.ticketsAparcados,
    getNpag: state => state.npag,
    getTotalPag:  state => state.totalPag,
    getTituloIcono: state => state.tituloIcono, 
    getTitulo: state => state.titulo,
    // getClienteId: state => state.clienteInfo.clienteId,
    // getClienteUid: state => state.clienteInfo.clienteUid,
    getCliente: state => state.clienteInfo.datos,
    getBusquedaCliente: state => state.clienteInfo.busquedaCliente,
    getLikeList: state => state.clienteInfo.likeList,
    isStaffControl: state => state.staffControl,
    getSesion: state => state.userInfo.sesion,
    // productsAdded: state => {
    //   return state.products.filter(el => {
    //     return el.isAddedToCart;
    //   });
    // },
    getParametrosApp: state => state.parametrosApp,
    getArticuloCart: state => data => {
      let itemAux = '';
      state.productsCart.forEach((item) => {
        if (data.id === item.id && data.codigo === item.codigo) {
          itemAux = item
        }
      },itemAux);
      return itemAux
    },
    getProductById: state => id => {
      return state.products.find(product => product.id == id);
    },
    isCheckoutModalOpen: state => {
      return state.systemInfo.openCheckoutModal;
    },
    isCarritoModalOpen: state => {
      return state.systemInfo.openCarritoModal;
    },
    quantity: state => {
      return state.products.quantity;
    },
    isFiltroOpen : state => {
      return state.systemInfo.openFiltro;
    },
    isFiltroTicketsOpen : state => {
      return state.systemInfo.openFiltroTickets;
    },
    isFiltroLooksOpen : state => {
      return state.systemInfo.openFiltroLooks;
    },
    isBusquedaOpen : state => {
      return state.systemInfo.openBusqueda;
    },
    isTicketsOpen : state => {
      return state.systemInfo.openTickets;
    }
  },
  mutations: {
    saveLang(state, lang) {
      state.lang = lang;
    },
    login_success(state, payload){
      state.loginSuccess = true;
      state.userName = payload.userName;
      // state.userPass = payload.userPass;
      state.acl = payload.acl;
      state.iniOps = payload.iniOps;
      state.userInfo.uid = payload.userUid;
    },
    login_error(state, payload){
        state.loginError = true;
        state.userName = payload.userName;
    },
    logout(state){
      state.loginSuccess = false;
      state.userName = null;
      state.userPass = null;
      state.userInfo.sesion = null;
      state.acl = null;
    },
    cambioTienda(state, id){
      state.idTienda = id;
      if(state.listaTiendaIds.find(element => element.id == id)) {
        state.opuid = state.listaTiendaIds.find(element => element.id == id).opuid;
        state.wsid = state.listaTiendaIds.find(element => element.id == id).wsid;
      }
      state.productsCart = []
    },
    cambioPag: (state, data)  => {
      state.npag = data
    },
    addToCart: (state, data) => {
      let pass = false
       state.productsCart.forEach(el => {
        if (data.id === el.id && data.codigo === el.codigo) {
          if (el.cantidad + data.cantidad > data.stock)  {
            console.log ("stock excedido")
          } else {
            el.cantidad = el.cantidad + data.cantidad;
          }
          pass = true;
        }
      }, pass);
      if (!pass) {
       state.productsCart.push(Object.assign({}, data));
      }
    },
    addNotaLinea: (state, data) => {
       state.productsCart.forEach(el => {
        if (data.id === el.id && data.codigo === el.codigo) {
          el.nota = data.nota
          el.coste = data.coste
        }
      });
    },
    // setAddedBtn: (state, data) => {
    //   state.products.forEach(el => {
    //     if (data.id === el.id) {
    //       el.isAddedBtn = data.status;
    //     }
    //   });
    // },
    removeFromCart: (state, data) => {
      state.productsCart.forEach(function (item, index) {
        if (data.id === item.id && data.codigo === item.codigo) {
          state.productsCart.splice(index,1);
        }
      });
    },
    removeFromTicketsAparcados: (state, id) => {
      state.ticketsAparcados.forEach(function (item, index) {
        if (id === item.cabecera.msct_uid) {
          state.ticketsAparcados.splice(index,1);
        }
      });
    },
    setHasUserSearched: (state, hasSearched) => {
      state.userInfo.hasSearched = hasSearched;
    },  
    setHasUserSearchedLook: (state, hasLookSearched) => {
      state.userInfo.hasLookSearched = hasLookSearched;
    }, 
    setHasTicketSearched: (state, hasTicketSearched) => {
      state.userInfo.hasTicketSearched = hasTicketSearched;
    },
    // setUserName: (state, name) => {
    //   state.userInfo.name = name;
    // },
    setProductTitleSearched: (state, titleSearched) => {
      state.userInfo.productTitleSearched = titleSearched;
    },
    setProductLocalizadorSearched: (state, productLocalizadorSearched) => {
      state.userInfo.productLocalizadorSearched = productLocalizadorSearched;
    },
    setProductEanSearched: (state, productEanSearched) => {
      state.userInfo.productEanSearched = productEanSearched;
    },
    setProductTemporadaSearched: (state, productTemporadaSearched) => {
      state.userInfo.productTemporadaSearched = productTemporadaSearched;
    },
    setProductColorSearched: (state, productColorSearched) => {
      state.userInfo.productColorSearched = productColorSearched;
    },
    setProductTallaSearched: (state, productTallaSearched) => {
      state.userInfo.productTallaSearched = productTallaSearched;
    },
    setTiendaSearched: (state, tiendaSearched) => {
      state.userInfo.tiendaSearched = tiendaSearched;
    },
    setProductFamiliaSearched: (state, productFamiliaSearched) => {
      state.userInfo.productFamiliaSearched = productFamiliaSearched;
    },
    setStockOnlineSearched: (state, stockOnlineSearched) => {
      state.userInfo.stockOnlineSearched = stockOnlineSearched;
    }, 
    setProductSeccionSearched: (state, productSeccionSearched) => {
      state.userInfo.productSeccionSearched = productSeccionSearched;
    },
    setProductPriceSearched: (state, priceSearched) => {
      state.userInfo.priceSearched = priceSearched;
    },
    setTicketVendedorSearched: (state, ticketVendedorSearched) => {
      state.userInfo.ticketVendedorSearched = ticketVendedorSearched;
    },
    setTicketClienteSearched: (state, ticketClienteSearched) => {
      state.userInfo.ticketClienteSearched = ticketClienteSearched;
    },
    setTicketFechaDesdeSearched: (state, ticketFechaDesdeSearched) => {
      state.userInfo.ticketFechaDesdeSearched = ticketFechaDesdeSearched;
    },
    setTicketFechaHastaSearched: (state, ticketFechaHastaSearched) => {
      state.userInfo.ticketFechaHastaSearched = ticketFechaHastaSearched;
    },
    setTicketTipoSearched: (state, ticketTipoSearched) => {
      state.userInfo.ticketTipoSearched = ticketTipoSearched;
    },
    setLookNombreSearched: (state, lookNombreSearched) => {
      state.userInfo.lookNombreSearched = lookNombreSearched;
    },
    setLookValidadoSearched: (state, lookValidadoSearched) => {
      state.userInfo.lookValidadoSearched = lookValidadoSearched
    },
    setLookLocalizadorSearched: (state, lookLocalizadorSearched) => {
      state.userInfo.lookLocalizadorSearched = lookLocalizadorSearched
    },
    showCheckoutModal: (state, show) => {
      state.systemInfo.openCheckoutModal = show;
    },
    showCarritoModal: (state, show) => {
      state.systemInfo.openCarritoModal = show;
    },
    showFiltro: (state, show) => {
      state.systemInfo.openFiltro = show;
    },
    showFiltroTickets: (state, show) => {
      state.systemInfo.openFiltroTickets = show;
    },
    showFiltroLooks: (state, show) => {
      state.systemInfo.openFiltroLooks = show;
    },
    showBusqueda: (state, show) => {
      state.systemInfo.openBusqueda = show;
    },
    showTickets: (state, show) => {
      state.systemInfo.openTickets = show;
    },
    setCliente: (state, cliente) => {
      // state.clienteInfo.clienteId = cliente.id;
      // state.clienteInfo.clienteUid = cliente.uid;
      state.clienteInfo.datos = cliente
    },
    setBusquedaCliente: (state, busqueda) => {
      state.clienteInfo.busquedaCliente = busqueda
    },
    setLikeList: (state, likeList) => {
      state.clienteInfo.likeList = likeList
    },
    addToLikeList: (state, id) => {
      state.clienteInfo.likeList.push({ idArtic : id})
    },
    deleteFromLikeList: (state, id) => {
      state.clienteInfo.likeList.splice(state.clienteInfo.likeList.findIndex(e => e.idArtic === id),1)
    },
    setSesion(state, data) {
      state.userInfo.sesion = data;
    },
    setParametrosApp: (state, parametros) => {
      state.parametrosApp = parametros
    }
    // quantity: (state, data) => {
    //   state.products.forEach(el => {
    //     if (data.id === el.id) {
    //       el.quantity = data.quantity;
    //     }
    //   });
    // },

  },
  actions: {
    saveLang(context, lang) {
      context.commit("saveLang", lang);
      sessionStorage.setItem('lang', lang);
    },
    cambioTienda({commit}, id){
      commit("cambioTienda", id);
    },
    setCliente({commit}, cliente){
      commit("setCliente", cliente);
    },
    setBusquedaCliente({commit}, busqueda){
      commit("setBusquedaCliente", busqueda);
    },
    login({commit}, {user, password, instalacion}) {
      return new Promise((resolve, reject) => {
          LoginApiService.postLogin(user, password, instalacion)
          .then(response => {
            if(response.status === 200) {
              this.state.listaTiendaIds = []
              if (response.data.rol.indexOf("Administrador") > 0 && Vue.prototype.isSys4Conjunto()) {
                this.state.userInfo.adminSYS4 = true
              }
              if (response.data.ops && response.data.ops !== null) {
                commit('login_success', {
                  userName: response.data.user.substring(0,50),
                  // userPass: password,
                  acl: response.data.acl,
                  iniOps: response.data.iniOps,
                  userUid: response.data.uid,
                });
                localStorage.setItem('user',response.data.user)
                localStorage.setItem('tokenOauth',response.data.tokenOauth)
                localStorage.setItem('token',response.data.token)
                localStorage.setItem('useruid',response.data.uid)
                localStorage.setItem('userId', response.data.idReprese)
                localStorage.setItem('instalacion', response.data.instalacion)
                //console.log(response.data.acl);
                let listaTiendaIdsAux = []
                response.data.ops.forEach(el => {
                  let opAux = {
                    id: el.msopid,
                    nombre: el.msopnombre,
                    opuid: el.msopuid,
                    wsid: el.msopparentworkspace,
                    clicode: el.msopclicode
                  }
                  listaTiendaIdsAux.push(opAux)
                }, listaTiendaIdsAux);
                this.state.listaTiendaIds = listaTiendaIdsAux
                commit('cambioTienda', this.state.listaTiendaIds[0].id);
              } else {
                commit('login_error', {
                  userName: user
                });
                reject("No hay tiendas asociadas")
                  //TODO: no hay tiendas asociadas
              }
                
            }
            resolve(response)
          })
          .catch(error => {
              console.log(error);
              commit('login_error', {
                  userName: user
              });
              reject("Usuario o contraseña incorrecto")
          })
      })
    },
    loginStaff({commit}, {user, password, op}) {
      return new Promise((resolve, reject) => {
          LoginApiService.postLoginStaff(user, password, op)
          .then(response => {
            if(response.status === 200) {
              this.state.listaTiendaIds = []
              if (response.data.ops) {
                commit('login_success', {
                  userName: user,
                  userPass: password,
                  acl: response.data.acl,
                  iniOps: response.data.iniOps
                });
                localStorage.setItem('user',user);
                localStorage.setItem('tokenOauth',response.data.tokenOauth);
                localStorage.setItem('token',response.data.token);
                localStorage.setItem('useruid',response.data.uid);
                //console.log(response.data.acl);
                let listaTiendaIdsAux = []
                response.data.ops.forEach(el => {
                  let opAux = {
                    id: el.msopid,
                    nombre: el.msopnombre,
                    opuid: el.msopuid,
                    wsid: el.msopparentworkspace,
                    clicode: el.msopclicode
                  }
                  listaTiendaIdsAux.push(opAux)
                }, listaTiendaIdsAux);
                this.state.listaTiendaIds = listaTiendaIdsAux
                commit('cambioTienda', this.state.listaTiendaIds[0].id);
              } else {
                commit('login_error', {
                  userName: user
                });
                reject("No hay tiendas asociadas")
                  //TODO: no hay tiendas asociadas
              }
                
            }
          resolve(response)
          })
          .catch(error => {
              console.log("Error: " + error);
              commit('login_error', {
                  userName: user
              });
              reject("Usuario o contraseña incorrecto")
          })
      })
    },
    getParametrosApp () {
      return new Promise((resolve, reject) => {
        LoginApiService.getParametrosApp()
          .then(response => {
            console.log(response.data)
            this.state.parametrosApp = response.data
            resolve(response)
          })
          .catch(error => {
            console.log('Error: ' + error)
            reject(error)
          })
      })
    }
  },
  plugins: [
    createPersistedState()
  ]
})


  